import NavBar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/footer";
import { PageRoutes } from "./utils/pageRoutes";
import { useEffect, useState } from "react";

function PageRoute({ children }: any) {
   const [ppm, setPpm] = useState(false);
    useEffect(() => {
     const isPpmRoute = (
        // window.location.pathname === PageRoutes.ExecutiveSummary ||
          window.location.pathname === PageRoutes.Intro ||
          // window.location.pathname === PageRoutes.question ||
          // window.location.pathname === PageRoutes.qa ||
          window.location.pathname === PageRoutes.factSheet ||
          window.location.pathname === PageRoutes.Projections ||
          window.location.pathname === PageRoutes.ShareholderAgreement ||
          window.location.pathname === PageRoutes.businessPlan ||
          window.location.pathname === PageRoutes.ShareSubscriptionForm ||
          window.location.pathname === PageRoutes.SafeFrom ||
          window.location.pathname === PageRoutes.SafeAgreement ||
          window.location.pathname === PageRoutes.CorporateGovernancePolicy ||
          //  window.location.pathname === PageRoutes.faq ||
          window.location.pathname === PageRoutes.Preview ||
          window.location.pathname === PageRoutes.AntiFraudPolicy ||
          window.location.pathname === PageRoutes.WhistleblowerPolicy ||
          window.location.pathname === PageRoutes.DataSecurityPolicy ||
          window.location.pathname === PageRoutes.PrivacyPolicy ||
          window.location.pathname === PageRoutes.TeamsOfUse ||
          window.location.pathname === PageRoutes.CookiePolicy ||
          window.location.pathname === PageRoutes.InvestorRelationsPolicy ||
          window.location.pathname === PageRoutes.AI_Executive_Summary 
      );
      document.body.style.background = isPpmRoute ? `linear-gradient(135deg, #01001f 0%, #002 25%, #00001e 50%, #010123 100%)` : "none";
     
    }, [window.location.pathname]);
  return (
    <>
    
        {<NavBar />}
        {children}
        {window.location.pathname !== PageRoutes.ExecutiveSummary &&
          window.location.pathname !== PageRoutes.Intro &&(
            <Footer />
          )}
     
    </>
  );
}

export default PageRoute;
